import { render, staticRenderFns } from "./NotifyComponent.vue?vue&type=template&id=10c5d434&scoped=true"
import script from "./NotifyComponent.vue?vue&type=script&lang=js"
export * from "./NotifyComponent.vue?vue&type=script&lang=js"
import style0 from "./NotifyComponent.vue?vue&type=style&index=0&id=10c5d434&prod&scoped=true&lang=css"
import style1 from "./NotifyComponent.vue?vue&type=style&index=1&id=10c5d434&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c5d434",
  null
  
)

export default component.exports